import {useRef} from 'react';
import {useDataFormContext} from '../contexts';

export const useFieldId = (valuePath: string): string => {
  const {id} = useDataFormContext();
  const fieldIdRef = useRef(`${id}:${valuePath}`);
  return fieldIdRef.current;
};
